export const verifications = {
  'TRC20': /T[A-Za-z1-9]{33}$/,
  'email': /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  'currency': /\B(?=(\d{3})+(?!\d))/g,
  'point': /\B(?=(\d{3})+(?!\d)(.[0-9]{4}))/g,
  'phone': /^9[0-9]{8}$|^[5,6,9][0-9]{7}$/,
  'phoneTW': /^9[0-9]{8}$/,
  'phoneHK': /^[5,6,9][0-9]{7}$/,
};